import { useEffect } from "react";
import { classNameParser, useOutsideClick } from "../../../helpers";
import { Props } from "../../../types";

import "./style.css";
import "../../../styles/typography.css";
import cross from "../../../images/ic-x-dark.svg";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

type SidePanelProps = Props<{
  active: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  onScroll?: (e: any) => void;
}>;

export const SidePanel = (props: SidePanelProps) => {
  const containerRef = useOutsideClick<HTMLDivElement>(null, () => {
    if (props.active && props.onClose) {
      props.onClose();
    }
  });

  useEffect(() => {
    if (props.active && props.onOpen) {
      props.onOpen();
      disableBodyScroll(document.body, { allowTouchMove: () => true });
    } else {
      enableBodyScroll(document.body);
    }
  }, [props.active, props.onOpen]);

  useEffect(() => {
    return () => {
      enableBodyScroll(document.body);
    };
  }, []);

  return (
    <>
      <div className={`side-panel--empty-box${props.active ? " open" : ""}`} />
      <div
        className={classNameParser(
          `side-panel--box${props.active ? " open" : ""}${
            props.active ? " shadow-[0_5px_3.5px_0px_rgba(0_0_0/0.23)]" : " "
          }`,
          props.className
        )}
        onScroll={(e: any) => props.onScroll && props.onScroll(e)}
        style={props.style}
        ref={containerRef}
        id={props?.id}
      >
        {props.onClose && (
          <div className="absolute right-[2.5rem] top-[2.5rem] cursor-pointer" onClick={props.onClose}>
            <img src={cross.src} className="h-[10px] w-[10px] md:h-[10px] md:w-[10px]" alt="Close" />
          </div>
        )}
        <div className="px-[48px] sm:px-[24px]">{props.children}</div>
      </div>
    </>
  );
};
